import MonkeyIdle from '../../../assets/tgs/monkeys/TwoFactorSetupMonkeyIdle.tgs';
import MonkeyTracking from '../../../assets/tgs/monkeys/TwoFactorSetupMonkeyTracking.tgs';
import MonkeyClose from '../../../assets/tgs/monkeys/TwoFactorSetupMonkeyClose.tgs';
import MonkeyPeek from '../../../assets/tgs/monkeys/TwoFactorSetupMonkeyPeek.tgs';

import FoldersAll from '../../../assets/tgs/settings/FoldersAll.tgs';
import FoldersNew from '../../../assets/tgs/settings/FoldersNew.tgs';

import Lock from '../../../assets/tgs/settings/Lock.tgs';
import Congratulations from '../../../assets/tgs/settings/Congratulations.tgs';
import Experimental from '../../../assets/tgs/settings/Experimental.tgs';

import CameraFlip from '../../../assets/tgs/calls/CameraFlip.tgs';
import HandFilled from '../../../assets/tgs/calls/HandFilled.tgs';
import HandOutline from '../../../assets/tgs/calls/HandOutline.tgs';
import Speaker from '../../../assets/tgs/calls/Speaker.tgs';
import VoiceAllowTalk from '../../../assets/tgs/calls/VoiceAllowTalk.tgs';
import VoiceMini from '../../../assets/tgs/calls/VoiceMini.tgs';
import VoiceMuted from '../../../assets/tgs/calls/VoiceMuted.tgs';
import VoiceOutlined from '../../../assets/tgs/calls/VoiceOutlined.tgs';

import JoinRequest from '../../../assets/tgs/invites/Requests.tgs';

import QrPlane from '../../../assets/tgs/auth/QrPlane.tgs';

//Ello .tgs
import DiscussionGroups from '../../../assets/tgs/panda/DiscussionGroupSetup.tgs';
import Invite from '../../../assets/tgs/panda/Invite.tgs';
import ChatListEmpty from '../../../assets/tgs/panda/ChatListEmpty.tgs';
import ChatListNoResults from '../../../assets/tgs/panda/ChatListNoResults.tgs';
import Hello1 from '../../../assets/tgs/panda/Hello_1.tgs';
import Hello2 from '../../../assets/tgs/panda/Hello_2.tgs';
import HelloAi from '../../../assets/tgs/panda/Hello_AI.tgs';
import HelloSupport from '../../../assets/tgs/panda/Hello_Support.tgs';
import NoContacts from '../../../assets/tgs/panda/NoContacts.tgs';
import ShareDone from '../../../assets/tgs/panda/ShareDone.tgs';
import SubscriptionChannel from '../../../assets/tgs/panda/SubscriptionChannel.tgs';
import PublicChannel from '../../../assets/tgs/panda/PublicChannel.tgs';
import PrivateChannel from '../../../assets/tgs/panda/PrivateChannel.tgs';
import OnlineCourse from '../../../assets/tgs/panda/OnlineCourse.tgs';
import FailDeposit from '../../../assets/tgs/panda/FailDeposit.tgs';
import SuccessfulDeposit from '../../../assets/tgs/panda/SuccessfulDeposit.tgs';
import FeedEmpty from '../../../assets/tgs/panda/FeedEmpty.tgs';
import Welcome from '../../../assets/tgs/panda/Welcome.tgs';
import Banned from '../../../assets/tgs/panda/Banned.tgs';
import SuccessSubscribed from '../../../assets/tgs/panda/SuccessSubscribed.tgs';
import Preloader from '../../../assets/tgs/panda/Preloader.tgs';

export const LOCAL_TGS_URLS = {
  MonkeyIdle,
  MonkeyTracking,
  MonkeyClose,
  MonkeyPeek,
  FoldersAll,
  FoldersNew,
  DiscussionGroups,
  Lock,
  CameraFlip,
  HandFilled,
  HandOutline,
  Speaker,
  VoiceAllowTalk,
  VoiceMini,
  VoiceMuted,
  VoiceOutlined,
  JoinRequest,
  Invite,
  QrPlane,
  Congratulations,
  Experimental,
  ChatListEmpty,
  ChatListNoResults,
  Hello1,
  Hello2,
  HelloAi,
  HelloSupport,
  NoContacts,
  ShareDone,
  SubscriptionChannel,
  PublicChannel,
  PrivateChannel,
  OnlineCourse,
  FailDeposit,
  SuccessfulDeposit,
  FeedEmpty,
  Welcome,
  Banned,
  SuccessSubscribed,
  Preloader,
};
